import { render, staticRenderFns } from "./withdraw_detail.vue?vue&type=template&id=86156f30&scoped=true&"
import script from "./withdraw_detail.vue?vue&type=script&lang=js&"
export * from "./withdraw_detail.vue?vue&type=script&lang=js&"
import style0 from "./withdraw_detail.vue?vue&type=style&index=0&id=86156f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86156f30",
  null
  
)

export default component.exports